import React from 'react';
import { useAppendix } from '../context/AppendixContext';
import { Maximize2, X } from 'lucide-react';

const AppendixTabsBar = () => {
    const { appendices, toggleMinimize, closeAppendix } = useAppendix();

    const minimizedAppendices = Object.values(appendices).filter(a => a.isOpen && a.isMinimized);

    if (minimizedAppendices.length === 0) return null;

    return (
        <div className="flex items-center gap-2 px-4 h-full border-l border-slate-800 animate-in slide-in-from-right-5">
            {minimizedAppendices.map((app) => (
                <div 
                    key={app.id}
                    className="group flex items-center gap-2 px-3 py-1.5 bg-slate-900 border border-slate-800 rounded-xl hover:bg-slate-800 transition-all cursor-pointer"
                    onClick={() => toggleMinimize(app.id)}
                >
                    {app.icon && <app.icon size={14} className="text-primary opacity-70 group-hover:opacity-100" />}
                    <span className="text-[10px] font-bold text-slate-300 uppercase tracking-tight truncate max-w-[120px]">
                        {app.title}
                    </span>
                    <button 
                        onClick={(e) => {
                            e.stopPropagation();
                            closeAppendix(app.id);
                        }}
                        className="p-1 hover:bg-slate-700 rounded-md text-slate-600 hover:text-red-400 transition-colors"
                    >
                        <X size={10} />
                    </button>
                </div>
            ))}
        </div>
    );
};

export default AppendixTabsBar;
